
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'


export default {
components:{
Group,
Tab,
Cell,
TabItem,
XButton,
XInput,
Selector
},
data () {
return {
eduList:[{key: 'YES', value: '确认故障'}, {key: "NO", value: '不是故障'}, {key: "INVALID", value: '无效'}],
result: 'YES',
iden:'',
orderDetail:{},
showLoading:false
}
},
methods:{
submit(){
this.showLoading = true;
console.log(this.result)
var header = {
headers:{
token:localStorage.getItem('token'),
opid:localStorage.getItem('userid')
}
}
let newobj = {
role:this.iden,
result:this.result
}
var that = this

this.$http.put('/api/v1/normalrepairs/'+ this.orderDetail.seq +'/confirm',newobj,header)
.then(res => {
that.$router.push({name:'engineer'})

})
.catch(error => {
that.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
this.showLoading = false
})


}
},
created (){
this.orderDetail = this.$route.params.obj
console.log(this.orderDetail)
if(this.orderDetail.confirm != 'WAIT'){
this.result = this.orderDetail.confirm
}
let opid = localStorage.getItem('userid');
var that = this
var header = {
headers:{
token:localStorage.getItem('token'),
opid:opid
}
}
this.$http.get('/api/v1/accounts/'+opid,header)
.then(function(res){

for (let i=0;i<res.data.length;i++){
if(res.data[i].type == 'EXPT'){
that.iden = 'EXPT'
}
if(res.data[i].type == 'SRVP'){
that.iden = 'SRVP'
}
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/confirmfault.vue